import React from "react";

import Typography from "@components/shared/Typography";

import { useTranslation } from "@lib/i18n";

import { useCEESubsidySelector } from "@redux/reducers/appConfig";
import { string } from "prop-types";

const CEESubsidyPanel = ({ ceeSubsidyType }) => {
  const { t } = useTranslation();
  const ceeSubsidy = useCEESubsidySelector(ceeSubsidyType);

  return (
    <div className="w-full max-w-pageContent m-auto px-2 md:px-8 my-8">
      <div className="w-full max-w-pageContent bg-primaryDark rounded-md px-4 py-2">
        <Typography className="text-xs text-primaryLight">
          {t(`ceeSubsidyNetPriceModal.${ceeSubsidyType}.text`, {
            amount: ceeSubsidy?.discountAmount || 0,
          })}
        </Typography>
      </div>
    </div>
  );
};

CEESubsidyPanel.propTypes = {
  ceeSubsidyType: string.isRequired,
};

export default CEESubsidyPanel;
